/**
 * TotalVet homepage banner marquee (port of initTopBannerMarquee in the WP theme's homepage_v3.js).
 * WP scrolls one copy of the items by -50% over max(20, 30 * width / 800) seconds.
 * Here the track holds two copies so the loop is seamless; it moves one full copy, so the
 * duration is doubled to keep the same scrolling speed.
 */
if (!customElements.get('tv-home-marquee')) {
  class TvHomeMarquee extends HTMLElement {
    connectedCallback() {
      this.group = this.querySelector('[data-marquee-group]');
      if (!this.group) return;
      this.update = this.update.bind(this);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.group);
      }
      this.update();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    update() {
      const width = this.group.scrollWidth;
      if (!width) return;
      const duration = 2 * Math.max(20, (30 * width) / 800);
      this.style.setProperty('--tv-home-banner-duration', `${duration.toFixed(2)}s`);
    }
  }

  customElements.define('tv-home-marquee', TvHomeMarquee);
}
